namespace GeniuzPOS.InventoryReport {
    export interface IcReport05AllForm {
    }

    export class IcReport05AllForm extends Serenity.PrefixedContext {
        static formKey = 'InventoryReport.IcReport05All';
    }
}
